module.exports = __webpack_public_path__ + "img/ki.f1d7866b.svg";